import {PaymentMethod} from '@wix/ambassador-cashier-pay-v2-payment-method/types'

export const isPaymentTokenizationSupported = (paymentMethods: PaymentMethod[] | undefined) =>
  !!paymentMethods?.length
